import regexps from '../constants/regexps';

export const emailValidator = (value) => regexps.email.test(value);
